import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import FloatingWhatsApp from "./FloatingWhatsApp";

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-[#FAFCFF] text-[#0F172A]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <Header />
      <main><Outlet /></main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
